import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
 
import './App.css';
import './component/css/style.css';
import './component/css/common.css';
import './component/css/admin.css';
 
 
 
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard'; 
import AdminKanban from './pages/admin/AdminKanban';
import AdminFileManager from './pages/admin/AdminFileManager';
import AdminTodoListPage from './pages/admin/AdminTodoListPage';
import AdminOperationManagement from './pages/admin/AdminOperationManagement';
import AdminStratagicManagement from './pages/admin/AdminStratagicManagement';
import AdminRegister from './pages/admin/AdminRegister';
import AdminRegConfirm from './pages/admin/AdminRegConfirm';

import AllAssignee from './pages/admin/AllAssignee';
import EditAssignee from './pages/admin/EditAssignee';
import ProjectDetails from './pages/admin/ProjectDetails';

import AdminOrganization from './pages/admin/AdminOrganization';
import ChatWindow from './pages/admin/ChatWindow';
import CreateChatRoom from './pages/admin/CreateChatRoom';


import SuperLogin from './pages/SuperAdmin/SuperLogin';
import SuperDashboard from './pages/SuperAdmin/SuperDashboard';
import SuperAllOrganization from './pages/SuperAdmin/SuperAllOrganization';

function App() {
  return (
    <Router>
      <div className="App">
        {/* <VisitorNavbar/> */}
        <main>
           

          <Routes>
          {/* <Route path="/admin/dashboard" element={<AdminDashboard />} /> */}
          <Route path="/" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} /> 
          <Route path="/admin/kanban" element={<AdminKanban />} /> 
          <Route path="/admin/file-manager" element={<AdminFileManager />} /> 
          <Route path="/admin/to-do-list" element={<AdminTodoListPage />} /> 
          <Route path="/admin/manage-operations" element={<AdminOperationManagement />} /> 
          <Route path="/admin/manage-strategic" element={<AdminStratagicManagement />} /> 
          <Route path="/create-account" element={<AdminRegister />} /> 
          <Route path="/registration-completed" element={<AdminRegConfirm />} /> 
          <Route path="/all-assignee" element={<AllAssignee />} /> 
          <Route path="/edit-assignee/:id" element={<EditAssignee />} /> 
          <Route path="/project/:id" element={<ProjectDetails />} /> 
          <Route path="/admin/organization" element={<AdminOrganization />} /> 
          <Route path="/chat-window" element={<ChatWindow />} /> 
          <Route path="/create-chat-window" element={<CreateChatRoom />} /> 
 
          




          <Route path="/superadmin/login" element={<SuperLogin />} /> 
          <Route path="/superadmin/dashboard" element={<SuperDashboard />} /> 
          <Route path="/superadmin/all-organization" element={<SuperAllOrganization />} /> 
          
          
          
          </Routes>

 



        </main>
        {/* <Footer/> */}
      </div>
    </Router>
  );
}

export default App;
